module.exports = __webpack_public_path__ + "img/27.407a097f.svg";